import { OrderCreateInputSchema, OrderStatus, OrderType, type Product } from "@/graphql/codegen/graphql"
import type { ProductSelectionItem, PurchaseOrderFormData } from "@/screens/Procurement/Supplier/types/types.ts"
import { getPOLocationAssociationId } from "@/screens/Procurement/utils/locationUtils"

export const getLocationIdPerProductList = (products: Product[] | ProductSelectionItem[]): string | null => {
  const productWithLocations = products.find(
    ({ locationsAssociations }) => Array.isArray(locationsAssociations) && locationsAssociations.length > 0
  )

  return productWithLocations?.locationsAssociations?.[0]?.locationAssociationId ?? null
}

export const getCompanyIdForProductList = (products: Product[] | ProductSelectionItem[]): string | null => {
  return products?.[0]?.companyId ?? products?.[0]?.company?.companyId ?? null
}

export const createPOFormData = (
  data: PurchaseOrderFormData,
  selectedProducts: ProductSelectionItem[]
): ReturnType<ReturnType<typeof OrderCreateInputSchema>["safeParse"]> => {
  const sourceLocationId = getPOLocationAssociationId(selectedProducts)

  const draftPO = OrderCreateInputSchema().safeParse({
    destinationLocationAssociationId: data.shipTo.locationAssociationId,
    warehouseAreaId: data.shipTo.warehouseAreaId,
    orderLines: selectedProducts.map((product) => {
      const defaultUoM = product.packageUsWeightUom

      return {
        numberOfPallets: 0,
        pricePerUom: 0,
        priceUomId: defaultUoM,
        productId: product.productId,
        productVersionId: product.versionId,
        quantityInUom: 0,
        uomId: defaultUoM,
      }
    }),
    shipViaCompanyId: data.shipViaCompanyId,
    status: OrderStatus.Draft,
    type: OrderType.PurchaseOrder,
    requestedDeliveryDate: null,
    sourceLocationAssociationId: sourceLocationId,
  })

  return draftPO
}
